<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.773 16.541c-1.058.02-1.951-.336-2.68-1.065-.73-.73-1.085-1.623-1.066-2.68.02-1.058.407-1.965 1.163-2.721l.433-.433 1.325 1.326.708-.707-1.326-1.326 1.414-1.414 1.326 1.326.707-.707-1.326-1.326 1.14-1.14a4.47 4.47 0 0 1 .286-.263l1.314 1.314.707-.707L14.74 4.86a3.868 3.868 0 0 1 1.571-.349c1.058-.019 1.952.336 2.681 1.065.73.73 1.084 1.623 1.065 2.681a3.869 3.869 0 0 1-.349 1.571l-.981-.981-.707.707 1.137 1.137c-.082.098-.17.194-.264.287l-1.139 1.139-1.149-1.149-.707.707 1.15 1.15-1.415 1.413-1.149-1.149-.707.707 1.149 1.15-.432.432c-.756.756-1.664 1.144-2.721 1.163Z" fill="url(#paint0_linear_11_448)" />
    <path d="M17.731 14.922c.142.142.21.32.204.533a.77.77 0 0 1-.232.544l-1.105 1.105c-1.272 1.271-2.78 1.975-4.526 2.111-1.746.136-3.28-.319-4.601-1.364L6.33 18.99l2.095 2.095c.142.142.21.32.204.532a.77.77 0 0 1-.233.544.771.771 0 0 1-.544.233.694.694 0 0 1-.532-.204l-5.237-5.238a.695.695 0 0 1-.205-.532.772.772 0 0 1 .233-.544.77.77 0 0 1 .544-.233.694.694 0 0 1 .532.204l2.096 2.095 1.14-1.14c-1.047-1.321-1.502-2.855-1.366-4.6.136-1.746.84-3.255 2.112-4.526L8.275 6.57c.15-.15.33-.228.544-.233a.694.694 0 0 1 .532.204c.142.142.21.32.204.532a.772.772 0 0 1-.233.544L8.218 8.723C7.153 9.788 6.6 11.057 6.562 12.531c-.04 1.474.446 2.716 1.455 3.725 1.01 1.01 2.251 1.495 3.725 1.456 1.474-.04 2.744-.591 3.808-1.656l1.105-1.105c.15-.15.331-.227.544-.233a.695.695 0 0 1 .532.204Z" fill="url(#paint1_linear_11_448)" />
    <defs>
      <linearGradient
        id="paint0_linear_11_448"
        x1="-10.84"
        y1="18.701"
        x2="11.122"
        y2="38.055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8B700" />
        <stop offset=".51" stop-color="#F87900" />
        <stop offset="1" stop-color="#AE35DD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11_448"
        x1="-10.84"
        y1="18.701"
        x2="11.122"
        y2="38.055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8B700" />
        <stop offset=".51" stop-color="#F87900" />
        <stop offset="1" stop-color="#AE35DD" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {}
</script>
